import {makeAutoObservable} from "mobx";
import {ViewController} from "data/types/structure";
import {injectable, inject} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {ISnackbarStore} from "data/stores/snackbar/snackbar.store";

export interface ISnackbarController extends ViewController {
	get isOpen(): boolean;
	get message(): string;
	callback: () => void;
	handleClose: () => void;
}

@injectable()
export class SnackbarController implements ISnackbarController {
	constructor(@inject(Bindings.SnackbarStore) public readonly _snackBarStore: ISnackbarStore) {
		makeAutoObservable(this);
	}

	get message(): string {
		return this._snackBarStore.content?.message ?? "";
	}

	callback = () => {
		this._snackBarStore.content?.callback?.();
		this.handleClose();
	};

	get isOpen(): boolean {
		return !!this.message.length;
	}

	handleClose = () => {
		this._snackBarStore.hideSnackBar();
	};
}
